"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.displayMixin = void 0;

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../utils");

var displayMixinBase = function displayMixinBase(_ref) {
  var display = _ref.display;
  return (0, _utils.ifProp)(display, "display: ".concat(display, ";"));
};

var displayMixin = (0, _stencilReactDesc.describe)(displayMixinBase).description('Adds a prop for CSS display.');
exports.displayMixin = displayMixin;
displayMixin.propTypes = {
  display: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'display' property for the element.")
};